import "./OrdersViewComponent.scss";
import template from "./OrdersViewComponent.html";
import {IComponentOptions} from "angular";
import {GTMConversionEventService} from "../../analytics/services/GTMConversionEventService";

export const OrdersView = "tfOrdersView";

export function ordersView(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: OrdersViewComponentController
    };
}

/** @ngInject */
export class OrdersViewComponentController {

    constructor(private readonly gtmConversionEventService: GTMConversionEventService) {
        this.gtmConversionEventService.sendPageView(
            {
                path: "orders",
                hostUrl: window.location.host,
                title: "Orders"
            }
        );
    }
}
